import React from 'react';
import Hero from '../components/Hero';
import PageTransition from '../components/PageTransition';

const About = () => {
  return (
    <PageTransition>
      <main className="flex-1 flex flex-col">
        <Hero page="about" />
        
        {/* Our Story Section */}
        <section className="w-full py-20 relative overflow-visible flex-1">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="grid lg:grid-cols-2 grid-cols-1 justify-items-center">
              {/* Image section - hidden on small screens */}
              <div className="relative hidden lg:block" style={{ perspective: '1000px' }}>
                <div className="rounded-2xl overflow-hidden shadow-md transform relative z-20 w-60 h-80 bg-white p-2">
                  <img
                    src="https://placehold.co/300x400/f3f4f6/8A8A8A?text=Custom+Design"
                    alt="Custom design process"
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
              </div>
              
              {/* Text section */}
              <div className="max-w-2xl text-left lg:pr-28 lg:-ml-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Story</h2>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Founded in 2015 by a team of passionate collectors and artists, HeroForge began as a small workshop in a garage. What started as a hobby quickly transformed into a mission to revolutionize the custom action figure industry.
                </p>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Today, we're proud to serve thousands of collectors worldwide, creating unique pieces that tell your story and showcase your imagination.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </PageTransition>
  );
};

export default About;